import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../services/common.service';
@Component({
  selector: 'app-info-detenteur',
  templateUrl: './info-detenteur.component.html',
  styleUrls: ['./info-detenteur.component.css']
})
export class InfoDetenteurComponent implements OnInit {

  @Input() chantier;
  @Input() edit: Boolean;
  @Input() hidetitle: Boolean;
  @Input() listeagence;
  resultType: any[] = [];
  resultAgence: any[] = [];
  resultTerritoire: any[] = [];
  dataAdresseBAK: any[] = [];
  codeActivite = '';
  agence = '';
  tarif = '';
  adresseAutoBAK: Boolean = false;
  constructor(public common: CommonService) { }

  ngOnInit() {
    const societe = this.common.local.getObject('paramSociete') || {};
    const site = this.common.getType('siteUtilisateur');
    const adresseAutoBAK = site['rechercheAdresse'] && (site['serviceAdresse'] &&
      site['serviceAdresse'].typeServiceAdresse &&
      site['serviceAdresse'].typeServiceAdresse.id === 2) ? true : false;
    this.adresseAutoBAK = (societe['rechercheAdresse'] && (societe['serviceAdresse'] &&
      societe['serviceAdresse'].typeServiceAdresse &&
      societe['serviceAdresse'].typeServiceAdresse.id === 2)) || adresseAutoBAK;
    this.listeagence = this.listeagence || [];
    this.agence = this.chantier['agence'] ? this.common.getItem(this.listeagence, this.chantier['agence'].id) : '';
    // this.tarif = this.chantier['type'] ? this.common.getItem(this.common.getType('typeclient'), this.chantier['type'].id) : '';
    this.codeActivite = this.chantier['codeActiviteDetenteur'] ?
      this.common.getItem(this.common.getType('listeCodeActivite'), this.chantier['codeActiviteDetenteur'].id) : '';
    this.searchCode();
    this.searchAgence();
  }

  searchCode(event?) {
    this.resultType = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    this.common.getType('listeCodeActivite').forEach(elt => {
      elt.libelleObjetEntite = elt.libelle;
      this.resultType.push(elt);
    });
  }

  searchAgence(event?) {
    this.resultAgence = [];
    this.listeagence.forEach(elt => {
      elt.libelleObjetEntite = elt.nom || elt.libelleObjetEntite;
      this.resultAgence.push(elt);
    });
  }

  searchAdresseBAK(event) {
    this.dataAdresseBAK = [];
    const param = {
      'servlet': 'DBGestionAdresseRecherche',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CHAINE_RECHERCHE': event
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');;
      if (this.common.verifySession(datas)) {
        this.dataAdresseBAK = datas.data;
        this.dataAdresseBAK.forEach(elt => {
          elt.id = elt.clefBAK;
          elt.libelleObjetEntite = elt.label;
        });
      }
    });
  }

  setValueAdresseBAK(value, name?) {
    if(value && (!value.numero || (value.numero && value.numero === '0'))) {
        value.numero = '';
    }
          
    this.chantier['adresse1Gardien'] = `${value.numero || ''} ${value.suffixe || ''}`;
    this.chantier['adresse2Gardien'] = `${value.typeVoie || ''} ${value.nomVoie || ''}`;
    this.chantier['adresse3Gardien'] = '';
    this.chantier['cpGardien'] = value.postcode;
    this.chantier['villeGardien'] = value.city;
  }
}
